import { ColumnSortProps } from "src/components/tableHeader/types";
import { DEFAULT_BENEFIT, TABLE_DATE_BASED_COLUMNS } from "src/constants/stats";
import { InsuranceKeyProps, CaseDetailProps as InsuranceProps } from "../components/manufacturer/stepperModal/types";
import { parseDateForSorting } from "./dateTime";



export const doesBenefitHasInOrOutNetwork = (insurance_data: InsuranceProps): string => {
  const { in_network_tab, out_network_tab } = insurance_data;
  const isInNetworkUpdated = Object.keys(in_network_tab).map((key: unknown) => {
    return DEFAULT_BENEFIT[key as InsuranceKeyProps] !== in_network_tab[key as InsuranceKeyProps].trim()
  })

  const isOutNetworkUpdated = Object.keys(out_network_tab).map((key: unknown) => {
    return DEFAULT_BENEFIT[key as InsuranceKeyProps] !== out_network_tab[key as InsuranceKeyProps].trim()
  })

  if (isInNetworkUpdated) return "in_network"
  else if (isOutNetworkUpdated) return "out_network"
  else return ""
}


export const sortTableColumns = <T>(
  value: string, 
  sortingConfig: ColumnSortProps, 
  setSortingConfig: (action: ColumnSortProps) => void,
  dataListsing: T[],
  updateDataListing: (newListing: T[]) => void
): void => {
  const order = sortingConfig.direction === "desc" ? "asc" : "desc";

  const action: ColumnSortProps = {
    direction: order,
    sort_by: value,
  };
  setSortingConfig(action);

  const clonedDataListing = structuredClone(dataListsing);
  if (clonedDataListing?.length === 0) return;

  if (TABLE_DATE_BASED_COLUMNS.includes(value)) {
    clonedDataListing.sort((item1, item2) => {
      const date1: Date | null = parseDateForSorting(item1[value as keyof T] as string);
      const date2: Date | null = parseDateForSorting(item2[value as keyof T] as string);
      if (date1 && date2) {
        return order === "asc" ? date1.getTime() - date2.getTime() : date2.getTime() - date1.getTime();
      } else if (date1) {
        return order === "asc" ? -1 : 1;
      } else if (date2) {
        return order === "asc" ? 1 : -1;
      } else {
        return 0;
      }
    });
  } else if (typeof clonedDataListing?.[0]?.[value as keyof T] === "number") {
    clonedDataListing.sort((item1, item2) => {
      if (order === "asc")
        return Number(item1[value as keyof T]) - Number(item2[value as keyof T]);
      else
        return Number(item2[value as keyof T]) - Number(item1[value as keyof T]);
    });
  } else if (typeof clonedDataListing?.[0]?.[value as keyof T] === "string") {
    clonedDataListing.sort((item1, item2) => {
      const val1 = String(item1[value as keyof T] || "").trim();
      const val2 = String(item2[value as keyof T] || "").trim();

      // Check if values are empty
      const isEmpty1 = val1 === "";
      const isEmpty2 = val2 === "";
      
      // If both empty or both not empty, sort normally
      if (isEmpty1 === isEmpty2) {
        if (order === "asc") {
          return val1.localeCompare(val2);
        } else {
          return val2.localeCompare(val1);
        }
      }
      
      // Put empty values at the bottom
      return isEmpty1 ? 1 : -1;
    });
  } else {
    clonedDataListing.sort((item1, item2) => {
      const val1 = String(item1[value as keyof T] || "").trim();
      const val2 = String(item2[value as keyof T] || "").trim();

      // Check if values are empty
      const isEmpty1 = val1 === "";
      const isEmpty2 = val2 === "";
      
      // If both empty or both not empty, sort normally
      if (isEmpty1 === isEmpty2) {
        if (order === "asc") {
          return val1.localeCompare(val2);
        } else {
          return val2.localeCompare(val1);
        }
      }
      
      // Put empty values at the bottom
      return isEmpty1 ? 1 : -1;
    });
  }

  updateDataListing(clonedDataListing);
};
